module.exports = __webpack_public_path__ + "static/media/modelS_Mobile_BackgroundPic.3a214620.jpg";